import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FinancialtransactionsService } from 'src/app/features/financial-transactions/services/financial-transactions.service';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.states';
import { FinancialTransactionActions } from 'src/app/features/financial-transactions/state/financial-transactions.action-types';

@Component({
  selector: 'app-cancel-investment-dialog',
  templateUrl: './cancel-investment-dialog.component.html',
  styleUrls: ['./cancel-investment-dialog.component.scss'],
})
export class CancelInvestmentDialogComponent implements OnInit {
  investment: any;
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<CancelInvestmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private financialTransactionsService: FinancialtransactionsService,
    private store: Store<AppState>
  ) {
    this.investment = data.investment;
  }

  ngOnInit(): void {}

  cancel(): void {
    this.dialogRef.close();
  }

  confirmCancellation(): void {
    this.isLoading = true;
    this.financialTransactionsService.cancelInvestment(this.investment._id).subscribe({
      next: () => {
        console.log('Investment cancelled successfully');
        // Reload financial transactions
        this.store.dispatch(FinancialTransactionActions.LoadAll());
        this.isLoading = false;
        this.dialogRef.close('cancelled');
      },
      error: err => {
        console.error('Error cancelling investment:', err);
        this.isLoading = false;
        this.dialogRef.close('error');
      },
    });
  }
}
